var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatusFailed = function SvgStatusFailed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C7.16 32 0 24.84 0 16S7.16 0 16 0s16 7.16 16 16-7.16 16-16 16zm6.92-21.52l-1.4-1.4-5.52 5.5-5.52-5.5-1.4 1.4 5.5 5.52-5.5 5.52 1.4 1.4 5.52-5.5 5.52 5.5 1.4-1.4-5.5-5.52 5.5-5.52z",
    fillRule: "evenodd"
  })));
};
export default SvgStatusFailed;